import { AppShell, Burger, Group, Text, NavLink, Menu, Avatar, ActionIcon } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  IconHome,
  IconServer,
  IconDatabase,
  IconKey,
  IconSettings,
  IconLogout,
  IconChevronDown,
} from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';

export function Layout() {
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 280,
        breakpoint: 'sm',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Burger opened={mobileOpened} onClick={toggleMobile} hiddenFrom="sm" size="sm" />
            <Burger opened={desktopOpened} onClick={toggleDesktop} visibleFrom="sm" size="sm" />
            <Text size="xl" fw={700}>
              pk8s.aops.dev
            </Text>
          </Group>

          {user && (
            <Menu position="bottom-end" width={200}>
              <Menu.Target>
                <ActionIcon variant="subtle" size="lg">
                  <Avatar
                    src={user.avatar_url}
                    alt={user.name || user.login}
                    size="sm"
                    radius="xl"
                  />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>
                  <Text size="sm" fw={500}>
                    {user.name || user.login}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {user.email}
                  </Text>
                </Menu.Label>
                <Menu.Divider />
                <Menu.Item leftSection={<IconLogout size={16} />} onClick={signOut}>
                  Sign out
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          )}
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <NavLink
          label="Home"
          leftSection={<IconHome size={16} />}
          active={isActive('/')}
          onClick={() => navigate('/')}
        />
        <NavLink
          label="Environments"
          leftSection={<IconServer size={16} />}
          active={isActive('/environments')}
          onClick={() => navigate('/environments')}
        />
        <NavLink
          label="Databases"
          leftSection={<IconDatabase size={16} />}
          active={isActive('/databases')}
          onClick={() => navigate('/databases')}
        />
        <NavLink
          label="API Keys"
          leftSection={<IconKey size={16} />}
          active={isActive('/api-keys')}
          onClick={() => navigate('/api-keys')}
        />
        
        <NavLink
          label="Admin"
          leftSection={<IconSettings size={16} />}
          rightSection={<IconChevronDown size={12} />}
          childrenOffset={28}
        >
          <NavLink
            label="Queue"
            active={isActive('/admin/queue')}
            onClick={() => navigate('/admin/queue')}
          />
          <NavLink
            label="Stats"
            active={isActive('/admin/stats')}
            onClick={() => navigate('/admin/stats')}
          />
          <NavLink
            label="Reconcile"
            active={isActive('/admin/reconcile')}
            onClick={() => navigate('/admin/reconcile')}
          />
        </NavLink>
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}

